import clone from 'lodash/clone'

export function getEmptyEvent() {
  return clone({
    eventSessions: [],
    eventTemplate: null,
    meta: [],
    ticketGroups: [],
    ticketTypes: [],
    venue: null,
  })
}

const defaultState = {
  activeEvent: getEmptyEvent(),
}

/**
 * @deprecated Use props instead of global-state to pass events between lists and event-modals.
 */
export default {
  namespaced: true,

  state: clone(defaultState),

  getters: {
    /**
     * @deprecated Use props instead of global-state to pass events between lists and event-modals.
     */
    activeEvent(state) {
      return state.activeEvent
    },
  },

  mutations: {
    /**
     * @deprecated Use props instead of global-state to pass events between lists and event-modals.
     */
    activeEvent(state, activeEvent) {
      state.activeEvent = activeEvent
    },
  },

  actions: {
    clearAll(context) {
      Object.keys(context.state).forEach((key) => {
        context.commit(key, defaultState[key])
      })
    },

    // TODO
    setActiveEvent({ commit }, payload = defaultState.activeEvent) {
      commit('activeEvent', payload)
    },
  },
}
